import { render, staticRenderFns } from "./riskTest.vue?vue&type=template&id=47936d8e"
import script from "./riskTest.vue?vue&type=script&lang=js"
export * from "./riskTest.vue?vue&type=script&lang=js"
import style0 from "./riskTest.vue?vue&type=style&index=0&id=47936d8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports